import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

import ListingBlock from '@/app/components/listing/ListingBlock.vue'
import EmptyListingBlock from './EmptyListingBlock.vue'

import type { ListView } from '@/models/docs.list'


export default /*@__PURE__*/_defineComponent({
  __name: 'LatestEpisodesBlock',
  props: {
    view: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.view && __props.view.hasDocs())
    ? (_openBlock(), _createBlock(ListingBlock, {
        key: 0,
        class: "latest-episodes",
        view: __props.view,
        docs: __props.view.docs().filteredDocs.slice(0, 3),
        cardProps: { mobileVariant: 'vertical' }
      }, null, 8, ["view", "docs"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(EmptyListingBlock, {
          class: "latest-episodes__empty-block",
          title: __props.view.pageTitle(),
          useDefaultImage: true
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("p", null, " Episodes from podcasts you follow will appear here. To follow a podcast, simply click the \"Follow\" button on the podcast page! ", -1)
          ]))]),
          _: 1
        }, 8, ["title"])
      ]))
}
}

})